// Config-driven migration map: legacy wakad.endeavourcastle.com -> pune.endeavourcastle.com.
// This is the single source of truth for redirect mapping. True 301s should be set at the
// legacy domain's edge/DNS/proxy (see /app/memory/wakad_migration.md). The SPA also self-heals
// legacy paths that land here via resolveLegacy() in NotFound.

const EXACT = {
  "/": "/locations/wakad",
  "/home": "/locations/wakad",
  "/index": "/locations/wakad",
  "/about": "/about",
  "/about-us": "/about",
  "/contact": "/contact",
  "/contact-us": "/contact",
  "/projects": "/projects",
  "/properties": "/projects",
  "/property": "/projects",
  "/new-projects": "/projects",
  "/wakad": "/locations/wakad",
  "/flats-in-wakad": "/locations/wakad",
  "/2-bhk-in-wakad": "/locations/wakad",
  "/3-bhk-in-wakad": "/locations/wakad",
};

const LOCALITY_KEYS = [
  ["hinjewadi", "/locations/hinjewadi"], ["hinjawadi", "/locations/hinjewadi"],
  ["balewadi", "/locations/balewadi"], ["baner", "/locations/baner"],
  ["kharadi", "/locations/kharadi"], ["viman", "/locations/viman-nagar"],
  ["wagholi", "/locations/wagholi"], ["hadapsar", "/locations/hadapsar"],
  ["undri", "/locations/undri"], ["wakad", "/locations/wakad"],
];

// Resolve a legacy path to a Pune target.
// allowDefault=false (SPA): return null when nothing matches so a real 404 is shown.
// allowDefault=true (edge/ops): fall back to the most relevant page, never blind homepage.
export function resolveLegacy(pathname, { allowDefault = false } = {}) {
  if (!pathname) return null;
  const p = (pathname.toLowerCase().replace(/\/+$/, "")) || "/";
  if (EXACT[p]) return EXACT[p];
  if (/contact/.test(p)) return "/contact";
  if (/about/.test(p)) return "/about";
  for (const [k, t] of LOCALITY_KEYS) if (p.includes(k)) return t;
  if (/(project|propert|flat|apartment|bhk|buy|sale|residential|commercial)/.test(p)) return "/projects";
  return allowDefault ? "/locations/wakad" : null;
}
